import type { AnmCatalogSectionTemplate } from "./anm-classification.catalog.types";

/** Estrutura normativa ANM — somente chaves i18n (textos em shared/i18n/translations/anm-classification/). */
export const ANM_CATALOG_TEMPLATE = [
  {
    "key": "cri",
    "labelKey": "sections.cri.label",
    "subtitleKey": "sections.cri.subtitle",
    "hasBignumber": true,
    "grades": [
      {
        "key": "ct",
        "code": "CT",
        "fullTitleKey": "grades.ct.fullTitle",
        "columns": [
          {
            "key": "ct-a",
            "letter": "a",
            "titleKey": "columns.ctA.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctA.score0"
              },
              {
                "score": 1,
                "textKey": "options.ctA.score1"
              },
              {
                "score": 4,
                "textKey": "options.ctA.score4"
              },
              {
                "score": 7,
                "textKey": "options.ctA.score7"
              }
            ]
          },
          {
            "key": "ct-b",
            "letter": "b",
            "titleKey": "columns.ctB.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctB.score0"
              },
              {
                "score": 3,
                "textKey": "options.ctB.score3"
              },
              {
                "score": 6,
                "textKey": "options.ctB.score6"
              }
            ]
          },
          {
            "key": "ct-c",
            "letter": "c",
            "titleKey": "columns.ctC.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctC.score0"
              },
              {
                "score": 1,
                "textKey": "options.ctC.score1"
              },
              {
                "score": 2,
                "textKey": "options.ctC.score2"
              },
              {
                "score": 3,
                "textKey": "options.ctC.score3"
              }
            ]
          },
          {
            "key": "ct-d",
            "letter": "d",
            "titleKey": "columns.ctD.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctD.score0"
              },
              {
                "score": 2,
                "textKey": "options.ctD.score2"
              },
              {
                "score": 5,
                "textKey": "options.ctD.score5"
              },
              {
                "score": 10,
                "textKey": "options.ctD.score10"
              }
            ]
          },
          {
            "key": "ct-e",
            "letter": "e",
            "titleKey": "columns.ctE.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctE.score0"
              },
              {
                "score": 4,
                "textKey": "options.ctE.score4"
              },
              {
                "score": 10,
                "textKey": "options.ctE.score10"
              }
            ]
          },
          {
            "key": "ct-f",
            "letter": "f",
            "titleKey": "columns.ctF.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctF.score0"
              },
              {
                "score": 4,
                "textKey": "options.ctF.score4"
              },
              {
                "score": 10,
                "textKey": "options.ctF.score10"
              }
            ]
          },
          {
            "key": "ct-g",
            "letter": "g",
            "titleKey": "columns.ctG.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctG.score0"
              },
              {
                "score": 6,
                "textKey": "options.ctG.score6"
              },
              {
                "score": 10,
                "textKey": "options.ctG.score10"
              }
            ]
          },
          {
            "key": "ct-h",
            "letter": "h",
            "titleKey": "columns.ctH.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctH.score0"
              },
              {
                "score": 2,
                "textKey": "options.ctH.score2"
              },
              {
                "score": 5,
                "textKey": "options.ctH.score5"
              },
              {
                "score": 10,
                "textKey": "options.ctH.score10"
              }
            ]
          },
          {
            "key": "ct-i",
            "letter": "i",
            "titleKey": "columns.ctI.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ctI.score0"
              },
              {
                "score": 2,
                "textKey": "options.ctI.score2"
              },
              {
                "score": 6,
                "textKey": "options.ctI.score6"
              },
              {
                "score": 8,
                "textKey": "options.ctI.score8"
              }
            ]
          },
          {
            "key": "ct-j",
            "letter": "j",
            "titleKey": "columns.ctJ.title",
            "options": [
              {
                "score": 1,
                "textKey": "options.ctJ.score1"
              },
              {
                "score": 2,
                "textKey": "options.ctJ.score2"
              },
              {
                "score": 3,
                "textKey": "options.ctJ.score3"
              }
            ]
          }
        ]
      },
      {
        "key": "ec",
        "code": "EC",
        "fullTitleKey": "grades.ec.fullTitle",
        "columns": [
          {
            "key": "ec-k",
            "letter": "k",
            "titleKey": "columns.ecK.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ecK.score0"
              },
              {
                "score": 3,
                "textKey": "options.ecK.score3"
              },
              {
                "score": 6,
                "textKey": "options.ecK.score6"
              },
              {
                "score": 10,
                "textKey": "options.ecK.score10"
              }
            ]
          },
          {
            "key": "ec-l",
            "letter": "l",
            "titleKey": "columns.ecL.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ecL.score0"
              },
              {
                "score": 3,
                "textKey": "options.ecL.score3"
              },
              {
                "score": 6,
                "textKey": "options.ecL.score6"
              },
              {
                "score": 10,
                "textKey": "options.ecL.score10"
              }
            ]
          },
          {
            "key": "ec-m",
            "letter": "m",
            "titleKey": "columns.ecM.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ecM.score0"
              },
              {
                "score": 2,
                "textKey": "options.ecM.score2"
              },
              {
                "score": 6,
                "textKey": "options.ecM.score6"
              },
              {
                "score": 10,
                "textKey": "options.ecM.score10"
              }
            ]
          },
          {
            "key": "ec-n",
            "letter": "n",
            "titleKey": "columns.ecN.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ecN.score0"
              },
              {
                "score": 2,
                "textKey": "options.ecN.score2"
              },
              {
                "score": 6,
                "textKey": "options.ecN.score6"
              },
              {
                "score": 10,
                "textKey": "options.ecN.score10"
              }
            ]
          },
          {
            "key": "ec-o",
            "letter": "o",
            "titleKey": "columns.ecO.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.ecO.score0"
              },
              {
                "score": 2,
                "textKey": "options.ecO.score2"
              },
              {
                "score": 4,
                "textKey": "options.ecO.score4"
              },
              {
                "score": 5,
                "textKey": "options.ecO.score5"
              }
            ]
          }
        ]
      },
      {
        "key": "psb",
        "code": "PSB",
        "fullTitleKey": "grades.psb.fullTitle",
        "columns": [
          {
            "key": "psb-p",
            "letter": "p",
            "titleKey": "columns.psbP.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.psbP.score0"
              },
              {
                "score": 2,
                "textKey": "options.psbP.score2"
              },
              {
                "score": 3,
                "textKey": "options.psbP.score3"
              },
              {
                "score": 5,
                "textKey": "options.psbP.score5"
              },
              {
                "score": 8,
                "textKey": "options.psbP.score8"
              },
              {
                "score": 10,
                "textKey": "options.psbP.score10"
              }
            ]
          },
          {
            "key": "psb-q",
            "letter": "q",
            "titleKey": "columns.psbQ.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.psbQ.score0"
              },
              {
                "score": 1,
                "textKey": "options.psbQ.score1"
              },
              {
                "score": 3,
                "textKey": "options.psbQ.score3"
              },
              {
                "score": 6,
                "textKey": "options.psbQ.score6"
              }
            ]
          },
          {
            "key": "psb-r",
            "letter": "r",
            "titleKey": "columns.psbR.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.psbR.score0"
              },
              {
                "score": 2,
                "textKey": "options.psbR.score2"
              },
              {
                "score": 4,
                "textKey": "options.psbR.score4"
              },
              {
                "score": 8,
                "textKey": "options.psbR.score8"
              }
            ]
          },
          {
            "key": "psb-s",
            "letter": "s",
            "titleKey": "columns.psbS.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.psbS.score0"
              },
              {
                "score": 2,
                "textKey": "options.psbS.score2"
              },
              {
                "score": 4,
                "textKey": "options.psbS.score4"
              },
              {
                "score": 8,
                "textKey": "options.psbS.score8"
              }
            ]
          },
          {
            "key": "psb-t",
            "letter": "t",
            "titleKey": "columns.psbT.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.psbT.score0"
              },
              {
                "score": 2,
                "textKey": "options.psbT.score2"
              },
              {
                "score": 4,
                "textKey": "options.psbT.score4"
              },
              {
                "score": 6,
                "textKey": "options.psbT.score6"
              },
              {
                "score": 8,
                "textKey": "options.psbT.score8"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "key": "dpa",
    "labelKey": "sections.dpa.label",
    "subtitleKey": "sections.dpa.subtitle",
    "hasBignumber": true,
    "grades": [
      {
        "key": "dpa",
        "code": "DPA",
        "fullTitleKey": "grades.dpa.fullTitle",
        "columns": [
          {
            "key": "dpa-a",
            "letter": "a",
            "titleKey": "columns.dpaA.title",
            "options": [
              {
                "score": 1,
                "textKey": "options.dpaA.score1"
              },
              {
                "score": 2,
                "textKey": "options.dpaA.score2"
              },
              {
                "score": 3,
                "textKey": "options.dpaA.score3"
              },
              {
                "score": 4,
                "textKey": "options.dpaA.score4"
              },
              {
                "score": 5,
                "textKey": "options.dpaA.score5"
              }
            ]
          },
          {
            "key": "dpa-b",
            "letter": "b",
            "titleKey": "columns.dpaB.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.dpaB.score0"
              },
              {
                "score": 3,
                "textKey": "options.dpaB.score3"
              },
              {
                "score": 5,
                "textKey": "options.dpaB.score5"
              },
              {
                "score": 10,
                "textKey": "options.dpaB.score10"
              }
            ]
          },
          {
            "key": "dpa-c",
            "letter": "c",
            "titleKey": "columns.dpaC.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.dpaC.score0"
              },
              {
                "score": 2,
                "textKey": "options.dpaC.score2"
              },
              {
                "score": 6,
                "textKey": "options.dpaC.score6"
              },
              {
                "score": 8,
                "textKey": "options.dpaC.score8"
              },
              {
                "score": 10,
                "textKey": "options.dpaC.score10"
              }
            ]
          },
          {
            "key": "dpa-d",
            "letter": "d",
            "titleKey": "columns.dpaD.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.dpaD.score0"
              },
              {
                "score": 1,
                "textKey": "options.dpaD.score1"
              },
              {
                "score": 3,
                "textKey": "options.dpaD.score3"
              },
              {
                "score": 5,
                "textKey": "options.dpaD.score5"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "key": "go",
    "labelKey": "sections.go.label",
    "subtitleKey": "sections.go.subtitle",
    "hasBignumber": true,
    "grades": [
      {
        "key": "go",
        "code": "GO",
        "fullTitleKey": "grades.go.fullTitle",
        "columns": [
          {
            "key": "go-a",
            "letter": "a",
            "titleKey": "columns.goA.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.goA.score0"
              },
              {
                "score": 1,
                "textKey": "options.goA.score1"
              },
              {
                "score": 8,
                "textKey": "options.goA.score8"
              },
              {
                "score": 10,
                "textKey": "options.goA.score10"
              }
            ]
          },
          {
            "key": "go-b",
            "letter": "b",
            "titleKey": "columns.goB.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.goB.score0"
              },
              {
                "score": 1,
                "textKey": "options.goB.score1"
              },
              {
                "score": 8,
                "textKey": "options.goB.score8"
              },
              {
                "score": 10,
                "textKey": "options.goB.score10"
              }
            ]
          },
          {
            "key": "go-c",
            "letter": "c",
            "titleKey": "columns.goC.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.goC.score0"
              },
              {
                "score": 1,
                "textKey": "options.goC.score1"
              },
              {
                "score": 8,
                "textKey": "options.goC.score8"
              },
              {
                "score": 10,
                "textKey": "options.goC.score10"
              }
            ]
          },
          {
            "key": "go-d",
            "letter": "d",
            "titleKey": "columns.goD.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.goD.score0"
              },
              {
                "score": 1,
                "textKey": "options.goD.score1"
              },
              {
                "score": 2,
                "textKey": "options.goD.score2"
              },
              {
                "score": 6,
                "textKey": "options.goD.score6"
              },
              {
                "score": 10,
                "textKey": "options.goD.score10"
              }
            ]
          },
          {
            "key": "go-e",
            "letter": "e",
            "titleKey": "columns.goE.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.goE.score0"
              },
              {
                "score": 1,
                "textKey": "options.goE.score1"
              },
              {
                "score": 10,
                "textKey": "options.goE.score10"
              }
            ]
          },
          {
            "key": "go-f",
            "letter": "f",
            "titleKey": "columns.goF.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.goF.score0"
              },
              {
                "score": 1,
                "textKey": "options.goF.score1"
              },
              {
                "score": 4,
                "textKey": "options.goF.score4"
              },
              {
                "score": 9,
                "textKey": "options.goF.score9"
              }
            ]
          },
          {
            "key": "go-g",
            "letter": "g",
            "titleKey": "columns.goG.title",
            "options": [
              {
                "score": 0,
                "textKey": "options.goG.score0"
              },
              {
                "score": 1,
                "textKey": "options.goG.score1"
              }
            ]
          }
        ]
      }
    ]
  }
] satisfies AnmCatalogSectionTemplate[];
